var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _ellipse38, _ellipse39, _ellipse40, _ellipse41, _ellipse42, _ellipse43, _ellipse44, _ellipse45, _ellipse46, _ellipse47, _ellipse48, _ellipse49, _ellipse50, _ellipse51, _ellipse52, _ellipse53, _ellipse54, _ellipse55, _ellipse56, _ellipse57, _ellipse58, _ellipse59, _ellipse60, _ellipse61, _ellipse62, _ellipse63, _ellipse64, _ellipse65, _ellipse66, _ellipse67, _ellipse68, _ellipse69, _ellipse70, _ellipse71, _ellipse72, _ellipse73, _ellipse74, _ellipse75, _ellipse76, _ellipse77, _ellipse78, _ellipse79, _ellipse80, _ellipse81, _ellipse82, _ellipse83, _ellipse84, _ellipse85, _ellipse86, _ellipse87, _ellipse88, _ellipse89, _ellipse90, _ellipse91, _ellipse92, _ellipse93, _ellipse94, _ellipse95, _ellipse96, _ellipse97, _ellipse98, _ellipse99, _ellipse100, _ellipse101, _ellipse102, _ellipse103, _ellipse104, _ellipse105, _ellipse106, _ellipse107, _ellipse108, _ellipse109, _ellipse110, _ellipse111, _ellipse112, _ellipse113, _ellipse114, _ellipse115, _ellipse116, _ellipse117, _ellipse118, _ellipse119, _ellipse120, _ellipse121, _ellipse122, _ellipse123, _ellipse124, _ellipse125, _ellipse126, _ellipse127, _ellipse128, _ellipse129, _ellipse130, _ellipse131, _ellipse132, _ellipse133, _ellipse134, _ellipse135, _ellipse136, _ellipse137, _ellipse138, _ellipse139, _ellipse140, _ellipse141, _ellipse142, _ellipse143, _ellipse144, _ellipse145, _ellipse146, _ellipse147, _ellipse148, _ellipse149, _ellipse150, _ellipse151, _ellipse152, _ellipse153, _ellipse154, _ellipse155, _ellipse156, _ellipse157, _ellipse158, _ellipse159, _ellipse160, _ellipse161, _ellipse162, _ellipse163, _ellipse164, _ellipse165, _ellipse166, _ellipse167, _ellipse168, _ellipse169, _ellipse170, _ellipse171, _ellipse172, _ellipse173, _ellipse174, _ellipse175, _ellipse176, _ellipse177, _ellipse178, _ellipse179, _ellipse180, _ellipse181, _ellipse182, _ellipse183, _ellipse184, _ellipse185, _ellipse186, _ellipse187, _ellipse188, _ellipse189, _ellipse190, _ellipse191, _ellipse192, _ellipse193, _ellipse194, _ellipse195, _ellipse196, _ellipse197, _ellipse198, _ellipse199, _ellipse200, _ellipse201, _ellipse202, _ellipse203, _ellipse204, _ellipse205, _ellipse206, _ellipse207, _ellipse208, _ellipse209, _ellipse210, _ellipse211, _ellipse212, _ellipse213, _ellipse214, _ellipse215, _ellipse216;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedRow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 114,
    viewBox: "0 0 253 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 2.97091)",
    fill: "#F29E4D"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 25.1338)",
    fill: "#F29E4D"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 14.0524)",
    fill: "#F29E4D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 2.97091)",
    fill: "#F29E4D"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 25.1338)",
    fill: "#F29E4D"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 14.0524)",
    fill: "#F29E4D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 2.97091)",
    fill: "#F29E4D"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 25.1338)",
    fill: "#F29E4D"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 14.0524)",
    fill: "#F29E4D"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 2.97091)",
    fill: "#F29E4D"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 25.1338)",
    fill: "#F29E4D"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 14.0524)",
    fill: "#F29E4D"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 2.97091)",
    fill: "#F29E4D"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 25.1338)",
    fill: "#F29E4D"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 14.0524)",
    fill: "#F29E4D"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 2.97091)",
    fill: "#F29E4D"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 25.1338)",
    fill: "#F29E4D"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 14.0524)",
    fill: "#F29E4D"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 2.97091)",
    fill: "#F29E4D"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 25.1338)",
    fill: "#F29E4D"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 14.0524)",
    fill: "#F29E4D"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 2.97091)",
    fill: "#F29E4D"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 25.1338)",
    fill: "#F29E4D"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 14.0524)",
    fill: "#F29E4D"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 2.97091)",
    fill: "#F29E4D"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 25.1338)",
    fill: "#F29E4D"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 14.0524)",
    fill: "#F29E4D"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 2.97091)",
    fill: "#F29E4D"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 25.1338)",
    fill: "#F29E4D"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 14.0524)",
    fill: "#F29E4D"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 2.97091)",
    fill: "#F29E4D"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 25.1338)",
    fill: "#F29E4D"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 14.0524)",
    fill: "#F29E4D"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 2.97091)",
    fill: "#F29E4D"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 25.1338)",
    fill: "#F29E4D"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 14.0524)",
    fill: "#F29E4D"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 2.97091)",
    fill: "#F29E4D"
  })), _ellipse38 || (_ellipse38 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 25.1338)",
    fill: "#F29E4D"
  })), _ellipse39 || (_ellipse39 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 14.0524)",
    fill: "#F29E4D"
  })), _ellipse40 || (_ellipse40 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 2.97091)",
    fill: "#F29E4D"
  })), _ellipse41 || (_ellipse41 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 25.1338)",
    fill: "#F29E4D"
  })), _ellipse42 || (_ellipse42 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 14.0524)",
    fill: "#F29E4D"
  })), _ellipse43 || (_ellipse43 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 2.97091)",
    fill: "#F29E4D"
  })), _ellipse44 || (_ellipse44 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 25.1338)",
    fill: "#F29E4D"
  })), _ellipse45 || (_ellipse45 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 14.0524)",
    fill: "#F29E4D"
  })), _ellipse46 || (_ellipse46 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 2.97091)",
    fill: "#F29E4D"
  })), _ellipse47 || (_ellipse47 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 25.1338)",
    fill: "#F29E4D"
  })), _ellipse48 || (_ellipse48 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 14.0524)",
    fill: "#F29E4D"
  })), _ellipse49 || (_ellipse49 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 2.97091)",
    fill: "#F29E4D"
  })), _ellipse50 || (_ellipse50 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 25.1338)",
    fill: "#F29E4D"
  })), _ellipse51 || (_ellipse51 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 14.0524)",
    fill: "#F29E4D"
  })), _ellipse52 || (_ellipse52 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 2.97091)",
    fill: "#F29E4D"
  })), _ellipse53 || (_ellipse53 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 25.1338)",
    fill: "#F29E4D"
  })), _ellipse54 || (_ellipse54 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 14.0524)",
    fill: "#F29E4D"
  })), _ellipse55 || (_ellipse55 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 2.97091)",
    fill: "#F29E4D"
  })), _ellipse56 || (_ellipse56 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 25.1338)",
    fill: "#F29E4D"
  })), _ellipse57 || (_ellipse57 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 14.0524)",
    fill: "#F29E4D"
  })), _ellipse58 || (_ellipse58 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 2.97091)",
    fill: "#F29E4D"
  })), _ellipse59 || (_ellipse59 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 25.1338)",
    fill: "#F29E4D"
  })), _ellipse60 || (_ellipse60 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 14.0524)",
    fill: "#F29E4D"
  })), _ellipse61 || (_ellipse61 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 2.97091)",
    fill: "#F29E4D"
  })), _ellipse62 || (_ellipse62 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 25.1338)",
    fill: "#F29E4D"
  })), _ellipse63 || (_ellipse63 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 14.0524)",
    fill: "#F29E4D"
  })), _ellipse64 || (_ellipse64 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 2.97091)",
    fill: "#F29E4D"
  })), _ellipse65 || (_ellipse65 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 25.1338)",
    fill: "#F29E4D"
  })), _ellipse66 || (_ellipse66 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 14.0524)",
    fill: "#F29E4D"
  })), _ellipse67 || (_ellipse67 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 2.97091)",
    fill: "#F29E4D"
  })), _ellipse68 || (_ellipse68 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 25.1338)",
    fill: "#F29E4D"
  })), _ellipse69 || (_ellipse69 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 14.0524)",
    fill: "#F29E4D"
  })), _ellipse70 || (_ellipse70 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 2.97091,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 2.97091)",
    fill: "#F29E4D"
  })), _ellipse71 || (_ellipse71 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 25.1338,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 25.1338)",
    fill: "#F29E4D"
  })), _ellipse72 || (_ellipse72 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 14.0524,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 14.0524)",
    fill: "#F29E4D"
  })), _ellipse73 || (_ellipse73 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 45.986)",
    fill: "#F29E4D"
  })), _ellipse74 || (_ellipse74 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 68.1489)",
    fill: "#F29E4D"
  })), _ellipse75 || (_ellipse75 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 57.0674)",
    fill: "#F29E4D"
  })), _ellipse76 || (_ellipse76 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 45.986)",
    fill: "#F29E4D"
  })), _ellipse77 || (_ellipse77 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 68.1489)",
    fill: "#F29E4D"
  })), _ellipse78 || (_ellipse78 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 57.0674)",
    fill: "#F29E4D"
  })), _ellipse79 || (_ellipse79 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 45.986)",
    fill: "#F29E4D"
  })), _ellipse80 || (_ellipse80 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 68.1489)",
    fill: "#F29E4D"
  })), _ellipse81 || (_ellipse81 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 57.0674)",
    fill: "#F29E4D"
  })), _ellipse82 || (_ellipse82 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 45.986)",
    fill: "#F29E4D"
  })), _ellipse83 || (_ellipse83 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 68.1489)",
    fill: "#F29E4D"
  })), _ellipse84 || (_ellipse84 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 57.0674)",
    fill: "#F29E4D"
  })), _ellipse85 || (_ellipse85 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.574,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.574 45.986)",
    fill: "#F29E4D"
  })), _ellipse86 || (_ellipse86 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 68.1489)",
    fill: "#F29E4D"
  })), _ellipse87 || (_ellipse87 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 57.0674)",
    fill: "#F29E4D"
  })), _ellipse88 || (_ellipse88 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 45.986)",
    fill: "#F29E4D"
  })), _ellipse89 || (_ellipse89 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 68.1489)",
    fill: "#F29E4D"
  })), _ellipse90 || (_ellipse90 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 57.0674)",
    fill: "#F29E4D"
  })), _ellipse91 || (_ellipse91 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 45.986)",
    fill: "#F29E4D"
  })), _ellipse92 || (_ellipse92 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 68.1489)",
    fill: "#F29E4D"
  })), _ellipse93 || (_ellipse93 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 57.0674)",
    fill: "#F29E4D"
  })), _ellipse94 || (_ellipse94 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 45.986)",
    fill: "#F29E4D"
  })), _ellipse95 || (_ellipse95 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 68.1489)",
    fill: "#F29E4D"
  })), _ellipse96 || (_ellipse96 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 57.0674)",
    fill: "#F29E4D"
  })), _ellipse97 || (_ellipse97 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 45.986)",
    fill: "#F29E4D"
  })), _ellipse98 || (_ellipse98 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 68.1489)",
    fill: "#F29E4D"
  })), _ellipse99 || (_ellipse99 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 57.0674)",
    fill: "#F29E4D"
  })), _ellipse100 || (_ellipse100 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 45.986)",
    fill: "#F29E4D"
  })), _ellipse101 || (_ellipse101 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 68.1489)",
    fill: "#F29E4D"
  })), _ellipse102 || (_ellipse102 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 57.0674)",
    fill: "#F29E4D"
  })), _ellipse103 || (_ellipse103 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 45.986)",
    fill: "#F29E4D"
  })), _ellipse104 || (_ellipse104 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 68.1489)",
    fill: "#F29E4D"
  })), _ellipse105 || (_ellipse105 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 57.0674)",
    fill: "#F29E4D"
  })), _ellipse106 || (_ellipse106 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 45.986)",
    fill: "#F29E4D"
  })), _ellipse107 || (_ellipse107 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 68.1489)",
    fill: "#F29E4D"
  })), _ellipse108 || (_ellipse108 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 57.0674)",
    fill: "#F29E4D"
  })), _ellipse109 || (_ellipse109 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 45.986)",
    fill: "#F29E4D"
  })), _ellipse110 || (_ellipse110 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 68.1489)",
    fill: "#F29E4D"
  })), _ellipse111 || (_ellipse111 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 57.0674)",
    fill: "#F29E4D"
  })), _ellipse112 || (_ellipse112 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 45.986)",
    fill: "#F29E4D"
  })), _ellipse113 || (_ellipse113 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 68.1489)",
    fill: "#F29E4D"
  })), _ellipse114 || (_ellipse114 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 57.0674)",
    fill: "#F29E4D"
  })), _ellipse115 || (_ellipse115 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 45.986)",
    fill: "#F29E4D"
  })), _ellipse116 || (_ellipse116 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 68.1489)",
    fill: "#F29E4D"
  })), _ellipse117 || (_ellipse117 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 57.0674)",
    fill: "#F29E4D"
  })), _ellipse118 || (_ellipse118 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 45.986)",
    fill: "#F29E4D"
  })), _ellipse119 || (_ellipse119 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 68.1489)",
    fill: "#F29E4D"
  })), _ellipse120 || (_ellipse120 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 57.0674)",
    fill: "#F29E4D"
  })), _ellipse121 || (_ellipse121 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 45.986)",
    fill: "#F29E4D"
  })), _ellipse122 || (_ellipse122 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 68.1489)",
    fill: "#F29E4D"
  })), _ellipse123 || (_ellipse123 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 57.0674)",
    fill: "#F29E4D"
  })), _ellipse124 || (_ellipse124 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 45.986)",
    fill: "#F29E4D"
  })), _ellipse125 || (_ellipse125 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 68.1489)",
    fill: "#F29E4D"
  })), _ellipse126 || (_ellipse126 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 57.0674)",
    fill: "#F29E4D"
  })), _ellipse127 || (_ellipse127 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 45.986)",
    fill: "#F29E4D"
  })), _ellipse128 || (_ellipse128 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 68.1489)",
    fill: "#F29E4D"
  })), _ellipse129 || (_ellipse129 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 57.0674)",
    fill: "#F29E4D"
  })), _ellipse130 || (_ellipse130 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 45.986)",
    fill: "#F29E4D"
  })), _ellipse131 || (_ellipse131 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 68.1489)",
    fill: "#F29E4D"
  })), _ellipse132 || (_ellipse132 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 57.0674)",
    fill: "#F29E4D"
  })), _ellipse133 || (_ellipse133 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 45.986)",
    fill: "#F29E4D"
  })), _ellipse134 || (_ellipse134 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 68.1489)",
    fill: "#F29E4D"
  })), _ellipse135 || (_ellipse135 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 57.0674)",
    fill: "#F29E4D"
  })), _ellipse136 || (_ellipse136 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 45.986)",
    fill: "#F29E4D"
  })), _ellipse137 || (_ellipse137 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 68.1489)",
    fill: "#F29E4D"
  })), _ellipse138 || (_ellipse138 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 57.0674)",
    fill: "#F29E4D"
  })), _ellipse139 || (_ellipse139 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 45.986)",
    fill: "#F29E4D"
  })), _ellipse140 || (_ellipse140 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 68.1489)",
    fill: "#F29E4D"
  })), _ellipse141 || (_ellipse141 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 57.0674)",
    fill: "#F29E4D"
  })), _ellipse142 || (_ellipse142 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 45.986,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 45.986)",
    fill: "#F29E4D"
  })), _ellipse143 || (_ellipse143 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 68.1489,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 68.1489)",
    fill: "#F29E4D"
  })), _ellipse144 || (_ellipse144 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 57.0674,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 57.0674)",
    fill: "#F29E4D"
  })), _ellipse145 || (_ellipse145 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 89.0012)",
    fill: "#F29E4D"
  })), _ellipse146 || (_ellipse146 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 111.164)",
    fill: "#F29E4D"
  })), _ellipse147 || (_ellipse147 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.327,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 228.327 100.083)",
    fill: "#F29E4D"
  })), _ellipse148 || (_ellipse148 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 89.0012)",
    fill: "#F29E4D"
  })), _ellipse149 || (_ellipse149 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 111.164)",
    fill: "#F29E4D"
  })), _ellipse150 || (_ellipse150 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 249.835,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 249.835 100.083)",
    fill: "#F29E4D"
  })), _ellipse151 || (_ellipse151 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 89.0012)",
    fill: "#F29E4D"
  })), _ellipse152 || (_ellipse152 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 111.164)",
    fill: "#F29E4D"
  })), _ellipse153 || (_ellipse153 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 239.081,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 239.081 100.083)",
    fill: "#F29E4D"
  })), _ellipse154 || (_ellipse154 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 89.0012)",
    fill: "#F29E4D"
  })), _ellipse155 || (_ellipse155 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 111.164)",
    fill: "#F29E4D"
  })), _ellipse156 || (_ellipse156 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.066,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 196.066 100.083)",
    fill: "#F29E4D"
  })), _ellipse157 || (_ellipse157 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 89.0012)",
    fill: "#F29E4D"
  })), _ellipse158 || (_ellipse158 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 111.164)",
    fill: "#F29E4D"
  })), _ellipse159 || (_ellipse159 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 217.573,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 217.573 100.083)",
    fill: "#F29E4D"
  })), _ellipse160 || (_ellipse160 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 89.0012)",
    fill: "#F29E4D"
  })), _ellipse161 || (_ellipse161 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 111.164)",
    fill: "#F29E4D"
  })), _ellipse162 || (_ellipse162 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.82,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 206.82 100.083)",
    fill: "#F29E4D"
  })), _ellipse163 || (_ellipse163 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 89.0012)",
    fill: "#F29E4D"
  })), _ellipse164 || (_ellipse164 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 111.164)",
    fill: "#F29E4D"
  })), _ellipse165 || (_ellipse165 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.805,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 163.805 100.083)",
    fill: "#F29E4D"
  })), _ellipse166 || (_ellipse166 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 89.0012)",
    fill: "#F29E4D"
  })), _ellipse167 || (_ellipse167 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 111.164)",
    fill: "#F29E4D"
  })), _ellipse168 || (_ellipse168 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.312,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 185.312 100.083)",
    fill: "#F29E4D"
  })), _ellipse169 || (_ellipse169 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 89.0012)",
    fill: "#F29E4D"
  })), _ellipse170 || (_ellipse170 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 111.164)",
    fill: "#F29E4D"
  })), _ellipse171 || (_ellipse171 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 174.558,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 174.558 100.083)",
    fill: "#F29E4D"
  })), _ellipse172 || (_ellipse172 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 89.0012)",
    fill: "#F29E4D"
  })), _ellipse173 || (_ellipse173 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 111.164)",
    fill: "#F29E4D"
  })), _ellipse174 || (_ellipse174 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.543,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 131.543 100.083)",
    fill: "#F29E4D"
  })), _ellipse175 || (_ellipse175 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 89.0012)",
    fill: "#F29E4D"
  })), _ellipse176 || (_ellipse176 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 111.164)",
    fill: "#F29E4D"
  })), _ellipse177 || (_ellipse177 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.051,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 153.051 100.083)",
    fill: "#F29E4D"
  })), _ellipse178 || (_ellipse178 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 89.0012)",
    fill: "#F29E4D"
  })), _ellipse179 || (_ellipse179 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 111.164)",
    fill: "#F29E4D"
  })), _ellipse180 || (_ellipse180 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.297,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 142.297 100.083)",
    fill: "#F29E4D"
  })), _ellipse181 || (_ellipse181 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 89.0012)",
    fill: "#F29E4D"
  })), _ellipse182 || (_ellipse182 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 111.164)",
    fill: "#F29E4D"
  })), _ellipse183 || (_ellipse183 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.2819,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 99.2819 100.083)",
    fill: "#F29E4D"
  })), _ellipse184 || (_ellipse184 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 89.0012)",
    fill: "#F29E4D"
  })), _ellipse185 || (_ellipse185 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 111.164)",
    fill: "#F29E4D"
  })), _ellipse186 || (_ellipse186 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.789,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 120.789 100.083)",
    fill: "#F29E4D"
  })), _ellipse187 || (_ellipse187 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 89.0012)",
    fill: "#F29E4D"
  })), _ellipse188 || (_ellipse188 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 111.164)",
    fill: "#F29E4D"
  })), _ellipse189 || (_ellipse189 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.036,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 110.036 100.083)",
    fill: "#F29E4D"
  })), _ellipse190 || (_ellipse190 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 89.0012)",
    fill: "#F29E4D"
  })), _ellipse191 || (_ellipse191 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 111.164)",
    fill: "#F29E4D"
  })), _ellipse192 || (_ellipse192 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.0206,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 67.0206 100.083)",
    fill: "#F29E4D"
  })), _ellipse193 || (_ellipse193 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 89.0012)",
    fill: "#F29E4D"
  })), _ellipse194 || (_ellipse194 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 111.164)",
    fill: "#F29E4D"
  })), _ellipse195 || (_ellipse195 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.5282,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 88.5282 100.083)",
    fill: "#F29E4D"
  })), _ellipse196 || (_ellipse196 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 89.0012)",
    fill: "#F29E4D"
  })), _ellipse197 || (_ellipse197 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 111.164)",
    fill: "#F29E4D"
  })), _ellipse198 || (_ellipse198 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.7743,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 77.7743 100.083)",
    fill: "#F29E4D"
  })), _ellipse199 || (_ellipse199 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 89.0012)",
    fill: "#F29E4D"
  })), _ellipse200 || (_ellipse200 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 111.164)",
    fill: "#F29E4D"
  })), _ellipse201 || (_ellipse201 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.7592,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 34.7592 100.083)",
    fill: "#F29E4D"
  })), _ellipse202 || (_ellipse202 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 89.0012)",
    fill: "#F29E4D"
  })), _ellipse203 || (_ellipse203 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 111.164)",
    fill: "#F29E4D"
  })), _ellipse204 || (_ellipse204 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.2667,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 56.2667 100.083)",
    fill: "#F29E4D"
  })), _ellipse205 || (_ellipse205 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 89.0012)",
    fill: "#F29E4D"
  })), _ellipse206 || (_ellipse206 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 111.164)",
    fill: "#F29E4D"
  })), _ellipse207 || (_ellipse207 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.5131,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 45.5131 100.083)",
    fill: "#F29E4D"
  })), _ellipse208 || (_ellipse208 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 89.0012)",
    fill: "#F29E4D"
  })), _ellipse209 || (_ellipse209 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 111.164)",
    fill: "#F29E4D"
  })), _ellipse210 || (_ellipse210 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.49793,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 2.49793 100.083)",
    fill: "#F29E4D"
  })), _ellipse211 || (_ellipse211 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 89.0012)",
    fill: "#F29E4D"
  })), _ellipse212 || (_ellipse212 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 111.164)",
    fill: "#F29E4D"
  })), _ellipse213 || (_ellipse213 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0055,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 24.0055 100.083)",
    fill: "#F29E4D"
  })), _ellipse214 || (_ellipse214 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 89.0012,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 89.0012)",
    fill: "#F29E4D"
  })), _ellipse215 || (_ellipse215 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 111.164,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 111.164)",
    fill: "#F29E4D"
  })), _ellipse216 || (_ellipse216 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.2516,
    cy: 100.083,
    rx: 2.76962,
    ry: 2.49792,
    transform: "rotate(90 13.2516 100.083)",
    fill: "#F29E4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedRow);
export default __webpack_public_path__ + "static/media/dotted-row.d0c02557e24cbbb690c1dc1aba8d1e7b.svg";
export { ForwardRef as ReactComponent };